import en from 'date-fns/locale/en-US'
import ka from 'date-fns/locale/ka'
import React, { useState } from 'react'
import DatePickerr from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
import { useAppSelector } from '../../store'
import { AppState } from '../../store/appSlice'
//
//
const DatePicker: React.FC<{
  maxDate?: Date | null
  minDate?: Date | null
  selectedDate?: Date | null
  placeholderText?: string
  selectsRangeOnchange?: (_: any) => void // return "date"
  onchange?: (_: any) => void
  open?: boolean
  dateFormat?: string
  selectsRange?: boolean
  label?: string
  className?: string
}> = ({
  maxDate = null,
  minDate = null,
  selectedDate,
  selectsRangeOnchange,
  onchange,
  placeholderText,
  open = undefined,
  dateFormat = 'dd/MM/yyyy',
  selectsRange = false,
  label,
  className = 'custom-date-picker',
}) => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  // START DATE
  const [startDate, setStartDate] = useState<Date | null>(selectedDate || null)
  //
  // END DATE
  const [endDate, setEndDate] = useState<Date | null>()
  //
  // SELECTED DATE
  const [selectedDateState, setSelectedDateState] = useState<Date | null | undefined>(selectedDate)
  //
  const selectRangeonChangeDate = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates
    //
    setStartDate(start)
    setEndDate(end)
    //
    selectsRangeOnchange?.({ start, end })
  }
  //
  return (
    <Wrapper>
      {label && <Label>{label}</Label>}
      <Content>
        {selectsRange && ( // SELECTED RANGE
          <DatePickerr
            maxDate={maxDate}
            minDate={minDate}
            selected={startDate}
            startDate={startDate}
            endDate={endDate}
            onChange={(date) => {
              selectRangeonChangeDate(date)
            }}
            selectsRange={selectsRange}
            open={open}
            placeholderText={placeholderText}
            showMonthDropdown={true}
            showYearDropdown={true}
            dropdownMode="select"
            locale={lang === 'ge' ? ka : en}
            className={className}
            onFocus={(e) => e.target.blur()}
            dateFormat={dateFormat}
            withPortal={false}
            onKeyDown={(e) => {
              e.preventDefault()
            }}
          />
        )}

        {/* ################################################## */}

        {!selectsRange && ( // ONLY SELECTED value
          <DatePickerr
            maxDate={maxDate}
            minDate={minDate}
            selected={selectedDateState || null}
            onChange={(date) => [onchange?.(date), setSelectedDateState(date)]}
            selectsRange={false}
            open={open}
            placeholderText={placeholderText}
            showMonthDropdown={true}
            showYearDropdown={true}
            dropdownMode="select"
            locale={lang === 'ge' ? ka : en}
            className={className}
            onFocus={(e) => e.target.blur()}
            dateFormat={dateFormat}
            withPortal={false}
            onKeyDown={(e) => {
              e.preventDefault()
            }}
          />
        )}
      </Content>
    </Wrapper>
  )
}
//
const Label = styled.div`
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 8px;
  text-align: left;
  padding-right: 24px;
  color: ${Colors.primaryGrey};
  margin-right: auto;
`
const Wrapper = styled.div`
  width: 100%;
`
const Content = styled.div`
  /*  */
  /*  */
  width: 100%;
  position: relative;
  /*  */
  .start-date-class {
    cursor: default;
  }
  /*  */
  .react-datepicker__portal {
    background-color: transparent;
  }
  /*  */
  .custom-date-picker {
    width: 100%;
  }
  /*  */
  .react-datepicker {
    font-family: inherit;
  }
  /*  */
  .react-datepicker__header__dropdown.react-datepicker__header__dropdown--select {
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 45%;
      margin-block: 10px;
      max-width: 100px;
      select {
        width: 100%;
        height: 30px;
        border-radius: 4px;
        border: unset;
        outline: 1px solid transparent;
        background-color: ${Colors.white};
        color: ${Colors.primaryBlack};
        font-weight: 600;
      }
    }
  }
  /* styles with className */
  .react-datepicker-wrapper {
    /* visibility: hidden; */
  }
  .react-datepicker__input-container {
    input {
      width: 100%;
      font-size: 14px;
      outline: none;
      border: 1px solid ${Colors.secondaryGrey};
      border-radius: 4px;
      height: 56px;
      padding: 18px 22px;
      color: ${Colors.primaryBlack};
      /*  */
      ${Responsive.mobile} {
        height: 48px;
      }
    }
  }
  .react-datepicker-ignore-onclickoutside {
    width: 100%;
  }
  .react-datepicker__triangle {
    display: none;
  }
  .react-datepicker__navigation--previous {
    left: -12px;
  }
  .react-datepicker__navigation--next {
    right: -12px;
  }
  .react-datepicker__month-container {
    padding-bottom: 5px;
    width: 100%;
    /* -webkit-box-shadow: 0px 0px 15px 3px #88888811;
    box-shadow: 0px 0px 15px 3px #88888811; */
  }
  .react-datepicker-popper {
    padding: 12px 5px 5px;
    background-color: ${Colors.white};
    /* -webkit-box-shadow: 0px 0px 15px 3px #88888811;
    box-shadow: 0px 0px 15px 3px #88888811; */
    border-radius: 8px;
    z-index: 3;
    /* top: 12px !important;
    left: 50% !important;
    transform: translate(-50%, 56px) !important; */

    ${Responsive.mobile} {
      padding: 0px;
    }
  }
  .react-datepicker__current-month {
    font-size: 18px;
    color: ${Colors.primaryBlack};
    font-weight: 500;
    line-height: 9px;
    margin-bottom: 20px;
  }
  .react-datepicker {
    border: 0px;
  }
  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-left-radius: 8px;
  }
  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-right-radius: 8px;
  }
  .react-datepicker__header {
    background-color: ${Colors.white};
    border-bottom: 0px;
  }
  .react-datepicker__day--selected {
    background-color: ${Colors.primaryRed} !important;
    color: ${Colors.white} !important;
    outline: none;
  }
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    width: 44px;
    /* height: 46px; */
    border-radius: 50% !important;
    text-align: center;
    line-height: 44px;
    font-size: 14px;
    font-weight: normal;
    outline: none;
    color: ${Colors.primaryGrey};

    ${Responsive.mobile} {
      width: 36px;
      line-height: 36px;
      font-size: 13px;
    }
  }
  .react-datepicker__day-names {
    .react-datepicker__day-name {
      font-size: 12px;
    }
  }
  .react-datepicker__day--selected:hover {
    background-color: ${Colors.primaryRed} !important;
    border-radius: 50% !important;
    font-size: 14px;
  }
  .react-datepicker__day:hover {
    background-color: ${Colors.primaryRed} !important;
    border-radius: 50% !important;
    color: ${Colors.white};
    font-size: 14px;
  }
  .react-datepicker__day--in-range {
    background-color: ${Colors.secondaryGrey};
    color: ${Colors.primaryBlack};
    border-radius: 0px;
  }
  .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ) {
    background-color: ${Colors.secondaryGrey};
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    background-color: transparent;
  }
  /* disable days */
  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    user-select: none;
    pointer-events: none;
    opacity: 0.3;
  }

  /*  */
  .react-datepicker__navigation {
    /* display: none; */
    top: 22px;
  }

  .react-datepicker__navigation--next {
    right: 0px;
  }
  .react-datepicker__navigation--previous {
    left: 0px;
  }

  /*  */
  .react-datepicker__current-month {
    display: none;
  }
  /*  */
  .react-datepicker__triangle {
    display: none;
  }
`
//
export default DatePicker
